import { PusherEvent, usePusherEvent } from '~publish/services/pusher'

const RELEVANT_EVENTS: Array<PusherEvent> = [
  PusherEvent.POST_CREATED,
  PusherEvent.POST_SENT,
  PusherEvent.POST_UPDATED,
  PusherEvent.POST_DELETED,
  PusherEvent.DRAFT_UPDATED,
  PusherEvent.DRAFT_APPROVED,
  PusherEvent.DRAFT_MOVED,
  PusherEvent.QUEUE_CHANGED,
  PusherEvent.POSTS_REORDERED,
]

const STREAK_UPDATE_EVENT_KEY = 'buffer.streak.update'

export function useStreaksAutoRefresh(): void {
  usePusherEvent(RELEVANT_EVENTS, () => {
    // Signal to the publish-frontend streaks widget to refetch
    window.dispatchEvent(new CustomEvent(STREAK_UPDATE_EVENT_KEY))
  })
}
